import { classNames } from '@/lib/utils';

export type EntertainmentPlayerIdentity = {
  id: string;
  name?: string | null;
  photo_url?: string | null;
  custom_photo_url?: string | null;
};

type Props = {
  user?: EntertainmentPlayerIdentity | null;
  fallbackId?: string;
  fallbackName?: string;
  className?: string;
  nameClassName?: string;
};

function displayNameFor(user?: EntertainmentPlayerIdentity | null, fallbackId?: string, fallbackName?: string) {
  return user?.name || fallbackName || fallbackId || 'Unknown player';
}

export function EntertainmentPlayerName({
  user,
  fallbackId,
  fallbackName,
  className,
  nameClassName,
}: Props) {
  const name = displayNameFor(user, fallbackId, fallbackName);
  const avatarSrc = user?.custom_photo_url || user?.photo_url || null;
  const testId = `entertainment-player-avatar-${user?.id ?? fallbackId ?? 'unknown'}`;

  return (
    <div className={classNames('flex min-w-0 items-center gap-2', className)}>
      <div
        data-testid={testId}
        className="flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-full bg-brand-primary text-[15px] font-extrabold text-surface"
        aria-hidden="true"
      >
        {avatarSrc ? (
          <img src={avatarSrc} alt="" className="h-full w-full object-cover" />
        ) : (
          name.charAt(0).toUpperCase()
        )}
      </div>
      <span className={classNames('min-w-0 truncate text-sm font-medium text-text-main', nameClassName)}>
        {name}
      </span>
    </div>
  );
}
